module.exports = __webpack_public_path__ + "img/cover-1.918c2b09.jpg";